import { requestGet } from '@/common/request';

interface ResultData {
  id: number; // 消息id
  title: String; //消息标题
  content: String; //消息内容
  sendDate: Date; //消息发送时间
  sourceCode: String; //来源code
  sourceName: String; //来源名称
  marketingType: String; //营销类型名称
  traceId: String; //用于埋点
}

/**
 * 消息中心-新消息弹窗提示
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1121439607
 */
export default function genericMessagePopup(): Promise<RequestResult<ResultData>> {
  return requestGet('/generic/platMktMsgBk/message/popup');
}
